import { Component, Output, EventEmitter, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-switch-buttons',
  templateUrl: './switch-buttons.component.html',
  styleUrls: ['./switch-buttons.component.scss'],
})


export class SwitchButtonsComponent implements OnInit {
  @Output() buttonClicked = new EventEmitter<string>();

  @Input() initBtnClicked: string;

  mapBtnStyles = {
    backgroundColor: '#171717CC',
    color: '#fff',
    imagePath: '../../../assets/icons/map-paper-light.svg',
  };

  treeBtnStyles = {
    backgroundColor: 'inherit',
    color: '#171717CC',
    imagePath: '../../../assets/icons/arrow-split-dark.svg',
  };

  btnActive: string = '';

  ngOnInit(): void{
    this.changeStylesByButtonActive(this.initBtnClicked);
  }
    
  onButtonClick(buttonClass: string){
    this.btnActive = buttonClass;
    this.changeStylesByButtonActive(this.btnActive);
    this.buttonClicked.emit(this.btnActive);
  }


  private changeStylesByButtonActive(btn: string): void{
    if(btn == 'map-btn'){
      this.mapBtnStyles = {
        backgroundColor: '#171717CC',
        color: '#fff',
        imagePath: '../../../assets/icons/map-paper-light.svg',
      }
      this.treeBtnStyles = {
        backgroundColor: 'inherit',
        color: '#171717CC',
        imagePath: '../../../assets/icons/arrow-split-dark.svg',
      };
    } else if (btn == 'tree-btn'){
      this.mapBtnStyles = {
        backgroundColor: 'inherit',
        color: '#171717CC',
        imagePath: '../../../assets/icons/map-paper-dark.svg',
      }
      this.treeBtnStyles = {
        backgroundColor: '#171717CC',
        color: '#fff',
        imagePath: '../../../assets/icons/arrow-split-light.svg',
      }
    }
  }


}

